import React from "react";
import { FieldProps } from "@rjsf/utils";
import { cloneDeep, get, isEmpty, set } from "lodash";
import { MultiSelectInput } from "../../../../../../Submissions/Fields";
import BaseFieldPreview from "./BaseFieldPreview";

const MultiSelectFieldPreview = (props: FieldProps) => {
  const oneOfOptions = get(props.schema, "items.oneOf") as Array<{
    const: string;
    title: string;
  }>;
  const schema = cloneDeep(props.schema);
  const filteredOneOf =
    oneOfOptions?.filter(option => {
      return (
        option &&
        option.const &&
        !isEmpty(option.const) &&
        option.title &&
        !isEmpty(option.title)
      );
    }) || [];
  set(schema, "items.oneOf", filteredOneOf);

  const widgetPreview = <MultiSelectInput {...props} schema={schema} />;

  return (
    <BaseFieldPreview
      widgetPreview={widgetPreview}
      {...props}
    ></BaseFieldPreview>
  );
};

export default MultiSelectFieldPreview;
